import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 5,
  label: "技术生命周期分析",
  chart: charts.lifeCycle,
  definition: {
    rowDims: [{ name: "appDate", label: "申请年", dateUnit: "YEAR", limit: 10 }],
    colDims: [],
    measures: [{ name: "count", label: "专利件数" }, {
      name: "applicant",
      label: "申请人数",
      table: "patent_applicant"
    }],
    showNoDataDims: false
  },
  chartOption: {
    chartType: ChartType.LINE,
    title: "技术生命周期分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "专利件数",
    yaxisTitle: "申请人数",
    hideAxisTitle: false,
    hideLabel: false,
    hideLegend: true,
    hideToolbox: false
  }
};
